import Vue from 'vue'
import ProtoBuilder from '../services/proto.service'
import {
  convertSessionDescriptionTypeIntToString,
  convertSessionDescriptionTypeStringToInt,
} from '../services/sessionDescription.type'
// import { stat } from 'fs'

const state = {
  protoBuilder: new ProtoBuilder(),
  peerConnectionConfig: {
    iceServers: [],
  },
  peerConnection: null,
  localStream: {},
  localStreamSettings: null,
  localVideo: null,
  localVideoSettings: null,
  remoteVideo: null,
  videoTrack: null,
  audioTrack: null,
  videoDeviceId: null,
  audioDeviceId: null,
  tenderness: null,
  devicesList: null,
}

const actions = {
  setupLocalStreamSettings({ state, rootState, dispatch }, { audio, video }) {
    const constant = { audio, video }

    navigator.mediaDevices.enumerateDevices().then(devices => {
      state.devicesList = devices
    })

    return navigator.mediaDevices
      .getUserMedia(constant)
      .then(stream => dispatch('gotLocalStreamSettings', stream))
  },
  setupLocalStream({ state, rootState, dispatch }, { audio, video }) {
    const constant = { audio: audio, video: video }
    return navigator.mediaDevices
      .getUserMedia(constant)
      .then(stream => dispatch('gotLocalStream', stream))
      .catch(e =>
        console.error(`getUserMedia() error: ${e.name} : ${e.message}`)
      )
  },
  gotLocalStream({ commit, dispatch }, stream) {
    commit('setLocalStream', { localStream: stream })
    // stream
    //   .getTracks()
    //   .forEach(track => state.peerConnection.addTrack(track, stream))
  },
  addVideo(state, stream) {
    if (stream) {
      stream
        .getTracks()
        .forEach(track => state.peerConnection.addTrack(track, stream))
    }
  },
  gotLocalStreamSettings({ state, commit }, stream) {
    var maxLevelL = 0
    var oldLevelL = 0
    checkTenderness(state, stream, maxLevelL, oldLevelL)

    return commit('setLocalStreamSettings', { localStream: stream })
  },
  gotRemoteStream({ state, commit }, stream) {
    if (state.remoteVideo.srcObject !== stream) {
      state.remoteVideo.srcObject = stream
      commit('changeStatus', '')
      console.log('Got Remote Stream')
    }
  },
  start({ state, dispatch }, { iceServers, isCaller }) {
    iceServers.forEach(iceServer => {
      state.peerConnectionConfig.iceServers.push({
        urls: iceServer.uri,
        credential: iceServer.password,
        username: iceServer.username,
      })
    })
    state.peerConnection = new RTCPeerConnection(state.peerConnectionConfig)
    state.peerConnection.onicecandidate = ({ candidate }) => {
      dispatch('onIceCandidate', { candidate })
    }
    state.peerConnection.ontrack = ({ streams }) => {
      dispatch('gotRemoteStream', streams[0])
    }

    if (state.localStream) {
      state.peerConnection.addStream(state.localStream)
    }
    if (isCaller) {
      // If we calling we need to create offer
      state.peerConnection.createOffer().then(description => {
        state.peerConnection
          .setLocalDescription(description)
          .then(() => {
            dispatch('sendSessionsDescription', {
              description,
              type: convertSessionDescriptionTypeStringToInt(description.type),
            })
          })
          .catch(e => console.error(e))
      })
    }
  },
  removeVideo({ dispatch }) {
    if (state.localStream) {
      // dispatch('sendRenegotiation')
      // state.peerConnection.removeTrack(state.videoTrack)
      if (state.videoTrack) {
        state.videoTrack.stop()
      }
      state.peerConnection.removeTrack(state.peerConnection.getSenders()[0])
    }
  },
  updateVideo({ dispatch }) {
    if (state.localStream) {
      state.localStreamSettings
        .getTracks()
        .forEach(track =>
          state.peerConnection.addTrack(track, state.localStream)
        )
    }
  },
  onIceCandidate({ dispatch }, { candidate }) {
    dispatch('sendIceCandidate', { candidate })
  },
  onIceCandidateAdd({ state }, iceCandidateAdd) {
    if (
      !state.peerConnection ||
      (!state.peerConnection && !state.peerConnection.remoteDescription.type)
    ) {
      iceCandidateAdd.iceCandidate.forEach(iceCandidate => {
        state.peerConnection
          .addIceCandidate(
            new RTCIceCandidate({
              sdpMid: iceCandidate.sdpMid,
              sdpMLineIndex: iceCandidate.sdpMLineIndex,
              candidate: iceCandidate.sdp,
            })
          )
          .then(() => {
            console.log('Added ice candidate')
          })
      })
    }
  },
  onIceCandidateRemoved({ state }, iceCandidateRemoved) {
    iceCandidateRemoved.iceCandidate.forEach(iceCandidate => {
      state.peerConnection
        .removedIceCandidate(
          new RTCIceCandidate({
            sdpMid: iceCandidate.sdpMid,
            sdpMLineIndex: iceCandidate.sdpMLineIndex,
            candidate: iceCandidate.sdp,
          })
        )
        .then(() => {
          console.log('Removed ice candidate')
        })
    })
  },
  onSessionsDescription({ state, dispatch, commit }, sessionsDescription) {
    state.peerConnection
      .setRemoteDescription(
        new RTCSessionDescription({
          type: convertSessionDescriptionTypeIntToString(
            sessionsDescription.type
          ),
          sdp: sessionsDescription.description,
        })
      )
      .then(() => {
        var status = state.peerConnection.signalingState
        if (
          status === 'have-remote-offer' ||
          status === 'have-local-pranswer'
        ) {
          state.peerConnection.createAnswer().then(description => {
            state.peerConnection
              .setLocalDescription(description)
              .then(() => {
                dispatch('sendSessionsDescription', {
                  description,
                  type: convertSessionDescriptionTypeStringToInt(
                    description.type
                  ),
                })
              })
              .catch(e => console.error(e))
          })
        }
      })
  },
}
const mutations = {
  setLocalVideo(state, { localVideo }) {
    Vue.set(state, 'localVideo', localVideo)
  },
  setLocalVideoSettings(state, { localVideo }) {
    Vue.set(state, 'localVideoSettings', localVideo)
  },

  microOff(state) {
    state.audioTrack.enabled = false
  },

  microOn(state) {
    state.audioTrack.enabled = true
  },

  setLocalStream(state, { localStream }) {
    state.videoTrack = localStream.getVideoTracks()[0]
    if (!state.audioTrack) {
      state.audioTrack = localStream.getAudioTracks()[0]
    }
    if (state.videoTrack) {
      state.videoDeviceId = state.videoTrack.getCapabilities().deviceId
    }
    if (state.audioTrack) {
      state.audioDeviceId = state.audioTrack.getCapabilities().deviceId
    }
    Vue.set(state, 'localStream', localStream)
    Vue.set(state.localVideo, 'srcObject', localStream)
  },

  setLocalStreamSettings(state, { localStream }) {
    Vue.set(state, 'localStreamSettings', localStream)
    Vue.set(state.localVideoSettings, 'srcObject', localStream)
  },
  setRemoteVideo(state, { remoteVideo }) {
    Vue.set(state, 'remoteVideo', remoteVideo)
  },
}

export default {
  state,
  actions,
  mutations,
}

function checkTenderness(state, stream, maxLevelL, oldLevelL) {
  var audioContext = new AudioContext()
  var microphone = audioContext.createMediaStreamSource(stream)
  var javascriptNode = audioContext.createScriptProcessor(1024, 1, 1)

  microphone.connect(javascriptNode)
  javascriptNode.connect(audioContext.destination)
  javascriptNode.onaudioprocess = function(event) {
    var inptL = event.inputBuffer.getChannelData(0)
    var instantL = 0.0

    var sumL = 0.0
    for (var i = 0; i < inptL.length; ++i) {
      sumL += inptL[i] * inptL[i]
    }
    instantL = Math.sqrt(sumL / inptL.length)
    maxLevelL = Math.max(maxLevelL, instantL)
    instantL = Math.max(instantL, oldLevelL - 0.008)
    oldLevelL = instantL

    state.tenderness = Math.round(800 * (instantL / maxLevelL))
  }
}
